import { IconProps } from "../types/icon";

export const CoffeeTakeAwayIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="m11 2-1-2H6L5 2H0v2h16V2zM1.2 6l.8 9.1c0 .5.5.9 1 .9h10c.5 0 .9-.4 1-.9l.8-9.1zM8 13c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2" />
      </g>
    </svg>
  );
};
